'use client';

import { AppPalettes, DesignSystemProvider } from '@prismo-io/design-system';
import '@prismo-io/design-system/module-augmentation';
import { SessionListener } from '@prismo-io/feature-auth/session-listener';
import { AppType, type LanguageCodeT } from '@prismo-io/schemas';
import { NpsSurveyProvider } from '@prismo-io/tracking';
import type { FC, ReactNode } from 'react';

type Props = {
  children: ReactNode;
  sessionAccessToken?: string;
  locale: LanguageCodeT;
};

export const GlobalProviders: FC<Props> = (props) => {
  const { children } = props;

  return (
    <>
      <SessionListener />
      <DesignSystemProvider theme={AppPalettes.light} options={{ key: 'mui' }}>
        <NpsSurveyProvider app={AppType.Enum.APP}>{children}</NpsSurveyProvider>
      </DesignSystemProvider>
    </>
  );
};
